// HTTP client com fetch, refresh automático em 401 e suporte a cookies httpOnly.
const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5107";
const TOKEN_KEY = "token";

let refreshPromise = null;

function getAccessToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAccessToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
}

function temIndicacaoDeSessao() {
  return Boolean(
    localStorage.getItem("usuario") || localStorage.getItem(TOKEN_KEY),
  );
}

async function refreshAccessToken() {
  if (refreshPromise) return refreshPromise;

  // Sem usuário persistido nem token: não há refresh-cookie esperado.
  // Evita 401 ruidoso no console em loads sem login prévio.
  if (!temIndicacaoDeSessao()) return null;

  refreshPromise = (async () => {
    const res = await fetch(`${BASE_URL}/auth/refresh`, {
      method: "POST",
      credentials: "include",
    });

    if (!res.ok) {
      setAccessToken(null);
      localStorage.removeItem("usuario");
      window.dispatchEvent(new Event("auth:sessao-expirada"));
      return null;
    }

    const data = await res.json();
    setAccessToken(data.accessToken);
    return data.accessToken;
  })();

  try {
    return await refreshPromise;
  } finally {
    refreshPromise = null;
  }
}

export class ApiError extends Error {
  constructor(message, status, body) {
    super(message);
    this.status = status;
    this.body = body;
  }
}

async function rawRequest(method, path, { body, headers, ...rest } = {}) {
  const token = getAccessToken();
  const isFormData = body instanceof FormData;

  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    credentials: "include",
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(!isFormData && body && { "Content-Type": "application/json" }),
      ...headers,
    },
    body: body == null ? undefined : isFormData ? body : JSON.stringify(body),
    ...rest,
  });

  return res;
}

async function request(method, path, options = {}) {
  let res = await rawRequest(method, path, options);

  // Tenta refresh em 401 (uma única vez por requisição)
  if (res.status === 401 && !options._retried) {
    const novoToken = await refreshAccessToken();
    if (novoToken) {
      res = await rawRequest(method, path, { ...options, _retried: true });
    }
  }

  if (res.status === 204) return null;

  const contentType = res.headers.get("content-type") || "";
  const data = contentType.includes("application/json")
    ? await res.json()
    : await res.text();

  if (!res.ok) {
    const message =
      (typeof data === "object" && (data.detail || data.error || data.title)) ||
      `Erro ${res.status}`;
    throw new ApiError(message, res.status, data);
  }

  return data;
}

export const apiClient = {
  get: (path, opts) => request("GET", path, opts),
  post: (path, body, opts) => request("POST", path, { ...opts, body }),
  put: (path, body, opts) => request("PUT", path, { ...opts, body }),
  patch: (path, body, opts) => request("PATCH", path, { ...opts, body }),
  delete: (path, opts) => request("DELETE", path, opts),
  upload: (path, formData, opts) =>
    request("POST", path, { ...opts, body: formData }),
  postForm: (path, formData, opts) =>
    request("POST", path, { ...opts, body: formData }),
};

export const BASE = BASE_URL;
